import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";
import { IAd, IAdBreakDonePlacementInfo, IAudio, IGame, IGameSnacks, IScore, IStorage } from "./GameSnacks";
import { IInit, IUser, Profile } from "./game_snacks/IUser";
import * as io from 'socket.io-client';
import ILiveMultiplayer, { DevSdkError, LiveEventData, LivePlayerDataEvent, LivePresenceAction, LiveRoomData } from "./game_snacks/ILiveMultiplayer";


export default class DummyGameSnacks extends PIXI.Container implements IGameSnacks
{
    public storage: GSStorage = null;
    public score: Score = null;
    public ad: Ad = null;
    public game: Game = null;
    public audio: Audio = null;
    public user: User = null;
    public liveMultiplayer: LiveMultiplayer = null;

    private _socket: SocketIOClient.Socket = null;;


    public constructor() 
    {
        super();

        this.storage = new GSStorage();
        this.score = new Score();
        this.ad = new Ad( this );
        this.game = new Game();
        this.audio = new Audio( this );
        this.user = new User();
        this.liveMultiplayer = new LiveMultiplayer();
    }

    public async init(): Promise<IInit>
    {
        return new Promise((resolve, reject) => {
            const kUrlParams = new URLSearchParams( window.location.search );
            const kRoomId = kUrlParams.has( "room" ) ? kUrlParams.get( "room" ) : null;
            //this._socket = io.connect( "http://localhost:2053", { query: { userId: ServiceLocator.saved.data.userId ? ServiceLocator.saved.data.userId : "user_" + ( Math.floor( Math.random() * 1000 ) ).toString(), roomId: kRoomId } } );
            this._socket = io.connect( "https://crazy-8s-server-render.onrender.com", { query: { userId: ServiceLocator.saved.data.userId ? ServiceLocator.saved.data.userId : "user_" + ( Math.floor( Math.random() * 1000 ) ).toString(), roomId: kRoomId } });

            // Callbacks.
            this._socket.on( "connectionAccepted", () => { 
                this.user.socket = this._socket;
                this.user.init();
                this.liveMultiplayer.socket = this._socket;
                this.liveMultiplayer.init();

                this._socket.on( "disconnect", () => {} );
                this._socket.on( "reconnect", () => {} );    
                
                resolve( { isInvite: kRoomId != null } ); 
            } );
            this._socket.on( "connect_error", () => { reject("connect error"); } );
            this._socket.on( "error",() => { reject("error"); } );
        });
    }
}

class GSStorage implements IStorage
{
    getItem(key: string): string {
        return window.localStorage.getItem( key );
    }
    setItem(key: string, value: string): void {
        window.localStorage.setItem( key, value );
    }
    removeItem(key: string): void {
        //throw new Error("Method not implemented.");
    }
    clear(): void {
        //throw new Error("Method not implemented.");
    }
}

class Ad implements IAd
{
    private _root: PIXI.Container = null;
    private _adWrapper: PIXI.Container = null;
    private _countdownText: PIXI.Text = null;
    private _breakRewardedData: any = null;
    private _breakInterstitialData: any = null;

    private _adInterval: number = null;
    private _countdown: number = null;

    public constructor( root: PIXI.Container ) 
    {
        this._root = root;

        this._adWrapper = new PIXI.Container();
        this._root.addChild( this._adWrapper );
    }

    break(o: any): void {
        if ( o.type == "reward" )
        {
            this._breakRewardedData = o;
            window.setTimeout( this._onBreakRewardedTimeout.bind( this ), null );
        }
        else
        {
            this._breakInterstitialData = o;
            window.setTimeout( this._onBreakInterstitialTimeout.bind( this ), null );
        }
    }

        _onBreakRewardedTimeout(): void
        {
            /*if ( Math.random() > 0.7 )
            {*/
                this._breakRewardedData.beforeReward( this._createRewardedAd.bind( this ) );
            /*}
            else
            {
                this._breakRewardedData.adBreakDone( {
                    breakType: "",
                    breakName: this._breakRewardedData.name,
                    breakFormat: "",
                    breakStatus: "" } );
            }*/
        }
        
            _createRewardedAd(): void
            {
                this._breakRewardedData.beforeAd();

                let disabledLayer: PIXI.Graphics = new PIXI.Graphics();
                disabledLayer.interactive = true;
                disabledLayer.beginFill( 0x000000, 0.6 );
                disabledLayer.drawRect( 0, 0, ServiceLocator.app.width, ServiceLocator.app.height );
                disabledLayer.endFill();
                this._adWrapper.addChild( disabledLayer );

                this._countdown = 3;

                this._countdownText = new PIXI.Text( this._countdown.toString(), { fill: 0xffffff } );
                this._countdownText.anchor.set( 0.5 );
                this._countdownText.position.set( disabledLayer.width * 0.5, disabledLayer.height * 0.5 );
                disabledLayer.addChild( this._countdownText );

                let dismissBtn: PIXI.Graphics = new PIXI.Graphics();
                dismissBtn.interactive = true;
                dismissBtn.buttonMode = true;
                dismissBtn.beginFill( 0xff0000 );
                dismissBtn.drawCircle( 0, 0, 25 );
                dismissBtn.endFill();
                dismissBtn.position.set( disabledLayer.width - 50, 100 );
                disabledLayer.addChild( dismissBtn );
                dismissBtn.on( "pointertap", this._onAdDismissed.bind( this ) );

                this._adInterval = window.setInterval( this._onRewardedAdInterval.bind( this ), 1000 );
            }

                _onRewardedAdInterval(): void
                {
                    this._countdown -= 1;

                    this._countdownText.text = this._countdown.toString();

                    if ( this._countdown < 0 )
                    {
                        window.clearInterval( this._adInterval );
                        this._adWrapper.removeChildren();

                        this._breakRewardedData.adBreakDone( {
                            breakType: "",
                            breakName: this._breakRewardedData.name,
                            breakFormat: "",
                            breakStatus: "viewed" } );
                    }
                }

                _onAdDismissed(): void
                {
                    window.clearInterval( this._adInterval );
                    this._adWrapper.removeChildren();

                    this._breakRewardedData.adBreakDone( {
                        breakType: "",
                        breakName: this._breakRewardedData.name,
                        breakFormat: "",
                        breakStatus: "" } );
                }

        _onBreakInterstitialTimeout(): void
        {
            this._createInterstitialAd();
        }

            _createInterstitialAd(): void
            {
                this._breakInterstitialData.beforeAd();

                let disabledLayer: PIXI.Graphics = new PIXI.Graphics();
                disabledLayer.interactive = true;
                disabledLayer.beginFill( 0x000000, 0.6 );
                disabledLayer.drawRect( 0, 0, ServiceLocator.app.width, ServiceLocator.app.height );
                disabledLayer.endFill();
                this._adWrapper.addChild( disabledLayer );

                this._countdown = 3;

                this._countdownText = new PIXI.Text( this._countdown.toString(), { fill: 0xffffff } );
                this._countdownText.anchor.set( 0.5 );
                this._countdownText.position.set( disabledLayer.width * 0.5, disabledLayer.height * 0.5 );
                disabledLayer.addChild( this._countdownText );

                this._adInterval = window.setInterval( this._onInterstitialAdInterval.bind( this ), 1000 );
            }

                _onInterstitialAdInterval(): void
                {
                    this._countdown -= 1;

                    this._countdownText.text = this._countdown.toString();

                    if ( this._countdown < 0 )
                    {
                        window.clearInterval( this._adInterval );
                        this._adWrapper.removeChildren();

                        this._breakInterstitialData.afterAd();
                    }
                }
}

class Score implements IScore
{
    update(score: number): void {
        //throw new Error("Method not implemented.");
    }
}

class Game implements IGame
{
    private _pauseCb: () => void = null;
    private _resumeCb: () => void = null;

    public constructor()
    {
        document.addEventListener( "visibilitychange", () => {
            if ( document.visibilityState === "visible" ) 
            {
                if ( this._resumeCb )
                {
                    this._resumeCb();
                }
            } 
            else 
            {
                if ( this._pauseCb )
                {
                    this._pauseCb();
                }
            }
        } );
    }
    
    public firstFrameReady(): void {}
    public ready(): void {}
    public levelComplete(level: number): void {}
    public gameOver(): void {}
    
    public onPause( cb: () => void ): void
    {
        this._pauseCb = cb;
    }

    public onResume( cb: () => void ): void
    {
        this._resumeCb = cb;
    }
}

class Audio implements IAudio
{
    private _toggleBtn: PIXI.Graphics = null;

    private _isEnabled: boolean = null;

    private _cb: (isEnabled: boolean) => void = null;


    public constructor( root: PIXI.Container )
    {
        this._isEnabled = true;

        this._toggleBtn = new PIXI.Graphics();
        this._updateButton();
        this._toggleBtn.x = ServiceLocator.app.width - 50;
        root.addChild( this._toggleBtn );
        this._toggleBtn.interactive = true;
        this._toggleBtn.buttonMode = true;
        this._toggleBtn.on( "pointertap", this._onToggleBtn_Click.bind( this ) );
    }

        private _onToggleBtn_Click(): void
        {
            this._isEnabled = !this._isEnabled;

            this._updateButton();

            this._cb( this._isEnabled );
        }

        private _updateButton(): void
        {
            this._toggleBtn.clear();
            this._toggleBtn.beginFill( this._isEnabled ? 0x00ff00 : 0xff0000 );
            this._toggleBtn.drawRect( 0, 0, 50, 50 );
            this._toggleBtn.endFill();
        }

    
    public isEnabled(): boolean { return this._isEnabled; }

    public subscribe( cb:  (isEnabled: boolean) => void): void
    {
        this._cb = cb;
    }
}

class User implements IUser 
{
    public socket: SocketIOClient.Socket = null;

    private _onProfileChangeCb: (profile?: Profile) => void = null;

    public init(): void
    {
        this.socket.on( "onProfileChange", ( profile: Profile ) => { 
            this._onProfileChangeCb( profile );
        } );
    }

    public onProfileChange(callback: (profile?: Profile) => void): void {
        this._onProfileChangeCb = callback;
    }

    public requestProfile(): Promise<Profile | undefined> {
        return new Promise((resolve, reject) => {
            let div = document.createElement( "div" );
            div.style.width = "100%";
            div.style.height = "100%";
            div.style.backgroundColor = "beige";
            div.style.position = "fixed";
            div.style.left = "0px";
            div.style.top = "0px";
            div.innerHTML = 
            "<div>"
                + "<div>Username</div>"
                + "<input id=\"username\" />"
                + "<div>Avatar</div>"
                + "<div>"
                    + "<label><input type=\"radio\" name=\"imageSelect\" value=\"0\" checked> Image 1</label><br>"
                    + "<label><input type=\"radio\" name=\"imageSelect\" value=\"1\"> Image 2</label><br>"
                    + "<label><input type=\"radio\" name=\"imageSelect\" value=\"2\"> Image 3</label><br>"
                    + "<label><input type=\"radio\" name=\"imageSelect\" value=\"3\"> Image 4</label>"

                    + "<div style=\"display:block;\">"
                        + "<img id=\"img1\" style=\"width:100px;\" src=\"./resources/img/common/avatar/0.svg?text=Image+1\">"
                        + "<img id=\"img2\" style=\"width:100px;\" src=\"./resources/img/common/avatar/1.svg?text=Image+2\">"
                        + "<img id=\"img3\" style=\"width:100px;\" src=\"./resources/img/common/avatar/2.svg?text=Image+3\">"
                        + "<img id=\"img4\" style=\"width:100px;\" src=\"./resources/img/common/avatar/3.svg?text=Image+4\">"
                    + "</div>"
                + "</div>"
                + "<div>"
                    + "<button id=\"acceptBtn\">Accept</button>"
                    + "<button id=\"cancelBtn\">Cancel</button>"
                + "</div>"
            + "</div>";
            document.body.append( div );

            let acceptBtn = document.getElementById( "acceptBtn" );
            acceptBtn.onclick = () => { 
                let username: HTMLInputElement = document.getElementById( "username" ) as HTMLInputElement;
                let selectedRadio: HTMLInputElement = document.querySelector('input[name="imageSelect"]:checked') as HTMLInputElement;

                if ( username.value.trim().length > 0 )
                {
                    ServiceLocator.multiplayerEventManager.onProfileChange.addOnce( ( profile: Profile ) => {
                        if ( profile )
                        {
                            div.parentElement.removeChild( div ); 
                            resolve( profile );
                        }
                    }, this );
                    this.socket.emit( "createProfile", username.value, parseInt( selectedRadio.value ) ) 
                }
                else
                {
                    div.parentElement.removeChild( div ); 
                    resolve( null );
                }
            };
            let cancelBtn = document.getElementById( "cancelBtn" );
            cancelBtn.onclick = () => { 
                div.parentElement.removeChild( div ); 
                resolve( null ); };
        });
    }
}

class LiveMultiplayer implements ILiveMultiplayer
{
    public socket: SocketIOClient.Socket = null;

    private _onRoomLoadedCb: (roomDataPromise: Promise<LiveRoomData>) => void = null;
    private _onPlayerPresenceUpdatedCb: (presenceEventPromise: Promise<LivePlayerDataEvent | DevSdkError>) => void = null;
    private _onEventsReceivedCb: (eventsReceivedPromise: Promise<LiveEventData[]>) => void = null;

    public init(): void
    {
        this.socket.on( "onRoomLoaded", ( liveRoomData: LiveRoomData ) => { 
            this._onRoomLoadedCb( new Promise((resolve, reject) => {
                resolve( liveRoomData );
         } ) ); 
        } );

        this.socket.on( "onPlayerPresenceUpdated", ( livePlayerDataEvent: LivePlayerDataEvent ) => { 
            this._onPlayerPresenceUpdatedCb( new Promise((resolve, reject) => {
                resolve( livePlayerDataEvent );
         } ) ); 
        } );

        this.socket.on( "onEventsReceived", ( arrLiveEventData: LiveEventData[] ) => { 
            this._onEventsReceivedCb( new Promise((resolve, reject) => {
                resolve( arrLiveEventData );
         } ) ); 
        } );
    }

    createRoom(): Promise<string> {
        return new Promise( ( resolve, reject ) => {
            this.socket.removeListener( "onRoomCreated" );
            this.socket.once( "onRoomCreated", ( gameId: string ) => {
                resolve( gameId );
            } );
            this.socket.emit( "createRoom" );
        } );
    }

    onRoomLoaded(callback: (roomDataPromise: Promise<LiveRoomData>) => void): void {
        this._onRoomLoadedCb = callback;
    }

    updatePlayerPresence(action: LivePresenceAction): Promise<void> {
        return new Promise( ( resolve, reject ) => {
            this.socket.emit( "updatePlayerPresence", action );
            resolve();
        } );
    }

    onPlayerPresenceUpdated(callback: (presenceEventPromise: Promise<LivePlayerDataEvent | DevSdkError>) => void): void {
        this._onPlayerPresenceUpdatedCb = callback;
    }
    
    sendEvent(event: LiveEventData): Promise<void> {
        return new Promise( ( resolve, reject ) => {
            this.socket.emit( "sendEvent", event );
            resolve();
        } );
    }

    onEventsReceived(callback: (eventsPromise: Promise<LiveEventData[]>) => void): void {
        this._onEventsReceivedCb = callback;
    }

    catchup(actionOrder: number): Promise<LiveEventData[]> {
        throw new Error("Method not implemented.");
    }

    getRoomUrl(): Promise<string> {
        throw new Error("Method not implemented.");
    }
}